import React, { useState } from "react";

const FAQsSection = ({ faqs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!faqs || faqs.length === 0) return null;

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-8 bg-gray-50">
      <h2 className="text-center text-2xl font-bold mb-6">Frequently Asked Questions</h2>
      <div className="max-w-4xl mx-auto space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`p-4 bg-white rounded-lg shadow-md cursor-pointer ${
              activeIndex === index ? "border-l-4 border-orange-500" : ""
            }`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="font-bold text-lg">{faq.question}</h3>
              <span className="text-orange-500">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            {activeIndex === index && (
              <p className="text-gray-600 mt-2">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQsSection;
